import "./repo.478a7f10.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire309d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire309d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jCupm", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b8863dd24b01c1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
const $41b8863dd24b01c1$var$HOME_URL = 'https://sideloop.golf';
function $41b8863dd24b01c1$export$2e2bcd8739ae039({ href: href = $41b8863dd24b01c1$var$HOME_URL, className: className = '', showTagline: showTagline = true }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `sl-brand ${className}`.trim(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                href: href,
                className: "sl-logo",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "sl-dollar-s",
                        children: "S"
                    }),
                    "ide Loop"
                ]
            }),
            showTagline && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "sl-tagline",
                children: [
                    "Every round has a ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                        className: "sl-accent",
                        children: "story."
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("9HyzH", function(module, exports) {

$parcel$export(module.exports, "initStickyFooter", () => $7102f3085be97910$export$d96815974b2f9261);
const $7102f3085be97910$var$FOOTER_ID = 'sl-sticky-footer';
const $7102f3085be97910$var$STYLE_ID = 'sl-sticky-footer-styles';
function $7102f3085be97910$export$d96815974b2f9261(options = {}) {
    if (typeof document === 'undefined') return;
    const { isLanding: isLanding = false } = options;
    if (!document.getElementById($7102f3085be97910$var$STYLE_ID)) {
        const style = document.createElement('style');
        style.id = $7102f3085be97910$var$STYLE_ID;
        style.textContent = `
      html, body { margin: 0; }
      body {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
      #root {
        flex: 1 0 auto;
        display: flex;
        flex-direction: column;
      }
      #${$7102f3085be97910$var$FOOTER_ID} {
        flex-shrink: 0;
        background: var(--sl-bg, transparent);
        border-top: 1px solid var(--sl-border, rgba(255,255,255,0.08));
        color: var(--sl-gray, #a0a0b0);
        font-size: 0.8rem;
        padding: 12px;
        text-align: center;
      }
      #${$7102f3085be97910$var$FOOTER_ID} a {
        color: var(--sl-green, #a0a0b0);
        text-decoration: underline;
        margin-left: 8px;
      }
    `;
        document.head.appendChild(style);
    }
    const existing = document.getElementById($7102f3085be97910$var$FOOTER_ID);
    if (existing) existing.remove();
    const footer = document.createElement('footer');
    footer.id = $7102f3085be97910$var$FOOTER_ID;
    const copyright = document.createTextNode("\xa9 2026 Side Loop Golf LLC. All rights reserved.");
    footer.appendChild(copyright);
    if (!isLanding) {
        const link = document.createElement('a');
        link.href = 'https://sideloop.golf';
        link.textContent = 'sideloop.golf';
        footer.appendChild(link);
    }
    if (document.body) document.body.appendChild(footer);
    else document.addEventListener('DOMContentLoaded', ()=>{
        document.body.appendChild(footer);
    }, {
        once: true
    });
}

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $jCupm = parcelRequire("jCupm");
var $828f32a7022055ab$exports = {};
$828f32a7022055ab$exports = import.meta.resolve("1Za13");


var $d9eccc5c86a0080b$exports = {};
$d9eccc5c86a0080b$exports = import.meta.resolve("5dSiF");


var $5ba96597d7b3a147$exports = {};
$5ba96597d7b3a147$exports = import.meta.resolve("hITcO");


var $aa674145cc5ec757$exports = {};
$aa674145cc5ec757$exports = import.meta.resolve("f13vG");


var $bbb77e2337e79efb$exports = {};
$bbb77e2337e79efb$exports = import.meta.resolve("25Oll");


var $34d1cbd1377f480b$exports = {};
$34d1cbd1377f480b$exports = import.meta.resolve("6uVf2");


var $9910bf37bbdd6fcf$exports = {};
$9910bf37bbdd6fcf$exports = import.meta.resolve("dViwC");


var $cac5536aecff85e4$exports = {};
$cac5536aecff85e4$exports = import.meta.resolve("j4ah5");


// import draftDark from 'url:./videos/draft-dark.mp4';
// import draftLight from 'url:./videos/draft-light.mp4';
// import pairingsDark from 'url:./videos/pairings-dark.mp4';
// import pairingsLight from 'url:./videos/pairings-light.mp4';
// import leaderboardDark from 'url:./videos/leaderboard-dark.mp4';
// import leaderboardLight from 'url:./videos/leaderboard-light.mp4';
const $1b8e0994176c9ade$var$APP_URL = 'https://app.sideloop.golf';
// ─────────────────────────────────────────────────────────────────
// ANNUAL PRICING CONFIG
// Update these values when you have final annual prices.
//   blueMonthlyDisplay  — the per-month equivalent shown on the card
//   champMonthlyDisplay — the per-month equivalent shown on the card
//   voiceMonthlyDisplay — the per-month equivalent shown on the Voice add-on card
//   blueTotalNote       — "Billed $XX.XX / year" note under price
//   champTotalNote      — "Billed $XX.XX / year" note under price
//   voiceTotalNote      — "Billed $XX.XX / year" note under Voice add-on price
//   blueSave            — savings badge on Blue Tees card
//   champSave           — savings badge on Championship Tees card
//   voiceSave           — savings badge on Voice Scoring card
//   topPill             — pill shown next to the Annual toggle button
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$ANNUAL = {
    blueMonthlyDisplay: '$5.00',
    champMonthlyDisplay: '$8.33',
    voiceMonthlyDisplay: '$4.16',
    blueTotalNote: 'Billed $59.99 / year',
    champTotalNote: 'Billed $99.99 / year',
    voiceTotalNote: 'Billed $49.99 / year',
    blueSave: 'Save 17%',
    champSave: 'Save 17%',
    voiceSave: 'Save 17%',
    topPill: 'Save 17%'
};
// ─────────────────────────────────────────────────────────────────
// HOOKS
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$useDeviceCycle(intervalMs = 5000) {
    const [deviceType, setDeviceType] = (0, $acw62.useState)('iphone');
    (0, $acw62.useEffect)(()=>{
        const timer = setInterval(()=>{
            setDeviceType((prev)=>prev === 'iphone' ? 'android' : 'iphone');
        }, intervalMs);
        return ()=>clearInterval(timer);
    }, [
        intervalMs
    ]);
    return deviceType;
}
function $1b8e0994176c9ade$var$useScreenCycle(intervalMs = 5000) {
    const [screenType, setScreenType] = (0, $acw62.useState)('tv');
    (0, $acw62.useEffect)(()=>{
        const timer = setInterval(()=>{
            setScreenType((prev)=>prev === 'tv' ? 'macbook' : 'tv');
        }, intervalMs);
        return ()=>clearInterval(timer);
    }, [
        intervalMs
    ]);
    return screenType;
}
function $1b8e0994176c9ade$var$useCurrentMode() {
    const [mode, setMode] = (0, $acw62.useState)(()=>document.documentElement.getAttribute('data-mode') || 'dark');
    (0, $acw62.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setMode(document.documentElement.getAttribute('data-mode') || 'dark');
        });
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: [
                'data-mode'
            ]
        });
        return ()=>observer.disconnect();
    }, []);
    return mode;
}
// ─────────────────────────────────────────────────────────────────
// ASSET CONFIG — uncomment imports at top of file as you add assets
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$PHONE_ASSETS = {
    scoring: {
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($828f32a7022055ab$exports))),
        light: (0, (/*@__PURE__*/$parcel$interopDefault($d9eccc5c86a0080b$exports)))
    },
    events: {
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($5ba96597d7b3a147$exports))),
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aa674145cc5ec757$exports)))
    },
    recap: {
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($bbb77e2337e79efb$exports))),
        light: (0, (/*@__PURE__*/$parcel$interopDefault($34d1cbd1377f480b$exports)))
    },
    settlement: {
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($9910bf37bbdd6fcf$exports))),
        light: (0, (/*@__PURE__*/$parcel$interopDefault($cac5536aecff85e4$exports)))
    }
};
const $1b8e0994176c9ade$var$VIDEO_ASSETS = {
    draft: {
        dark: null,
        light: null
    },
    pairings: {
        dark: null,
        light: null
    },
    leaderboard: {
        dark: null,
        light: null
    }
};
// ─────────────────────────────────────────────────────────────────
// MARQUEE ITEMS
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$MARQUEE_ITEMS = [
    'Nassau',
    'Skins',
    'Wolf',
    'Match Play',
    'Fives',
    'Tucson Twist',
    'Umbriago',
    'Stableford',
    'Snake',
    'Defender',
    'Hammer',
    'Vegas',
    'Bingo Bango Bongo',
    'Round Robin',
    'Rabbit',
    'Team Events',
    'Round Recaps',
    'Bet Settlement'
];
// ─────────────────────────────────────────────────────────────────
// MOCK ROWS (Scoring / Events / Recaps)
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$MOCK_ROWS = [
    {
        flip: false,
        assetKey: 'scoring',
        screenlabel: "App Screenshot \u2014 Scoring",
        label: 'Scoring',
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Simple scoring that",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "handles ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                    children: "everything."
                })
            ]
        }),
        body: 'Take the human element out of scoring, let Side Loop do the heavy lifting and simply enjoy the round with your friends.',
        bullets: [
            "Auto-defaults to par \u2014 just tap up or down",
            'Net stroke dots for every active game',
            'Live match play and Nassau standings per hole',
            'Multi-player sync for event group scoring',
            'Take complex scoring out of your hands'
        ]
    },
    {
        flip: true,
        assetKey: 'events',
        screenlabel: "App Screenshot \u2014 Event",
        label: 'Events',
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "From a foursome",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "to a ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                    children: "full event."
                })
            ]
        }),
        body: 'Create team events with 8 to 200+ players. Draft teams, set up multi-round scoring, assign groups, and let every group run their own side bets. Live leaderboards track points across rounds.',
        bullets: [
            'Snake or straight team draft',
            'Auto set group pairings by handicap',
            'Event-level + group-level side games',
            'Live scoring sync across all groups',
            'Online event leaderboard with public access'
        ]
    },
    {
        flip: false,
        assetKey: 'settlement',
        screenlabel: "App Screenshot \u2014 Settlement",
        label: 'Bet Settlement',
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Stack your games.",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "Settle in ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                    children: "seconds."
                })
            ]
        }),
        body: "Run as many side games as you want in a single round. Side Loop tracks every bet across every game and settles them all at once \u2014 optimized for the fewest transactions between players.",
        bullets: [
            "Nassau, Skins, Match Play, Wolf, Fives \u2014 all in one round",
            'Each game calculates independently with full accuracy',
            "Optimized payout grid \u2014 fewest transactions possible",
            'Net amounts per player across every active game',
            'No more napkin math at the 19th hole'
        ]
    },
    {
        flip: true,
        assetKey: 'recap',
        screenlabel: "App Screenshot \u2014 Recap",
        label: 'Recaps',
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Multiple voices.",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "One round.",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                    children: "Infinite laughs."
                })
            ]
        }),
        body: "Every score, streak, and blown lead \u2014 analyzed and turned into a personalized recap in the voice of your choosing. Share it and watch the replies roll in.",
        bullets: [
            "Roast Mode \u2014 savage, no mercy",
            'Famous movie characters and real-life celebrities',
            "Sunday at the Majors \u2014 Professional broadcaster reverence",
            'Auto-detects streaks, collapses, and comebacks',
            'Laugh at yourself and your friends'
        ]
    }
];
// ─────────────────────────────────────────────────────────────────
// WATCH LIVE ITEMS
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$WATCH_LIVE_ITEMS = [
    {
        flip: false,
        assetKey: 'draft',
        label: 'Live Draft',
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Watch captains build",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "their teams ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                    children: "live."
                })
            ]
        }),
        body: "Share the draft board link with friends, family, and players. Every pick, every steal, every Mr. Irrelevant \u2014 happening in real time on any screen."
    },
    {
        flip: true,
        assetKey: 'pairings',
        label: 'Live Pairings',
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Every round.",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "Every matchup.",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                    children: "Instantly."
                })
            ]
        }),
        body: "Pairings update live as captains set each round. Players and spectators always know exactly who's playing who \u2014 on their phone, tablet, or the clubhouse TV."
    },
    {
        flip: false,
        assetKey: 'leaderboard',
        label: 'Live Scoring',
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Hole by hole.",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "Every moment",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                    children: "captured."
                })
            ]
        }),
        body: "The leaderboard updates with every score entered from every group. Friends and family follow along from anywhere \u2014 no app needed, just a link."
    }
];
// ─────────────────────────────────────────────────────────────────
// FEATURES
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$FEATURES = [
    {
        num: '01',
        title: 'Simple Scoring',
        desc: 'Tap through each hole with auto-par defaults. Stroke indicators and net calculations update in real time for every game in play.'
    },
    {
        num: '02',
        title: '20 Betting Formats',
        desc: "Nassau, Skins, Wolf, Match Play, Fives, Tucson Twist, Umbriago, Vegas, Stableford, and 11 more \u2014 with presses, carryovers, birdie doubles, and automatic settlement."
    },
    {
        num: '03',
        title: 'Round Recaps in 20+ Voices',
        desc: "Choose from over 20 recap styles \u2014 from savage roasts to Shakespearean verse. Every streak, collapse, and comeback analyzed."
    },
    {
        num: '04',
        title: 'Team Events',
        desc: 'Run Ryder Cup-style events, large events, or your regular multi-group game. Draft teams, assign groups, configure multi-round scoring with live leaderboards.'
    },
    {
        num: '05',
        title: 'Group Betting',
        desc: "Each group in your event runs their own side games \u2014 Nassau, Skins, Match Play \u2014 independent from event scoring. Everyone gets their action."
    },
    {
        num: '06',
        title: 'Instant Settlement',
        desc: 'See exactly who owes who at the end of every round. No more napkin math at the 19th hole. Including the optimal payouts for the least transactions.'
    },
    {
        num: '07',
        title: 'Voice Scoring',
        desc: 'Score your round, configure games, and track shot details \u2014 all by voice. Say "Jason got a birdie" or "set up a $5 Nassau" and the AI handles the rest.',
        badge: 'Add-On'
    }
];
// ─────────────────────────────────────────────────────────────────
// RECAP SAMPLES
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$RECAPS = [
    {
        style: "\uD83D\uDD25 Roast Mode",
        quote: '"Four consecutive bogeys starting on the easiest hole on the course. That\'s not a slump, that\'s a lifestyle choice. Someone check if Dave\'s clubs are from a yard sale..."'
    },
    {
        style: "\uD83C\uDFAD Shakespeare",
        quote: '"Hark! Upon the seventh fairway, fortune\'s wheel did turn most cruel. Three strokes above the mark, a tragedy most foul, as bogey\'s shadow fell upon the green..."'
    },
    {
        style: "\u26F3 Sunday at the Majors",
        quote: '"And as the afternoon shadows stretched across the 18th green, what began as a quiet Sunday round had become something far more memorable..."'
    }
];
// ─────────────────────────────────────────────────────────────────
// EVENT FEATURES
// ─────────────────────────────────────────────────────────────────
const $1b8e0994176c9ade$var$EVENT_FEATURES = [
    {
        title: 'Team Draft',
        desc: 'Snake or straight draft with captain picks. Or assign teams manually.'
    },
    {
        title: 'Group Pairings',
        desc: 'Auto-pair by handicap or manually assign matchups for each round.'
    },
    {
        title: 'Live Scoring',
        desc: 'Every group scores simultaneously with real-time sync across devices.'
    },
    {
        title: 'Leaderboard',
        desc: 'Publicly accessible per-round and overall standings with team points and individual stats.'
    }
];
// ─────────────────────────────────────────────────────────────────
// NAV
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Nav() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
        className: "site-nav",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCupm.default), {
                showTagline: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "nav-right",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "nav-links",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "#watch-live",
                            children: "Watch Live"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "#features",
                            children: "Features"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "#events",
                            children: "Events"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "#recaps",
                            children: "Recaps"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "#pricing",
                            children: "Pricing"
                        })
                    ]
                })
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────
// HERO
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Hero() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hero-glow"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "hero-eyebrow fade-up delay-1",
                children: "The home of the side action"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                className: "hero-h1 fade-up delay-2",
                children: [
                    "Every round",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "has a",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                        children: "story."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "hero-subtitle fade-up delay-3",
                children: "Score it simply. Bet on it seriously. Settle it quickly. Run events your way. Then let Side Loop write the recap that tells your story."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hero-buttons fade-up delay-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "#features",
                    className: "btn-secondary btn-secondary--featured",
                    children: "See How It Works"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "scroll-indicator fade-up delay-5",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "scroll-line"
                })
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────
// MARQUEE
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Marquee() {
    const items = [
        ...$1b8e0994176c9ade$var$MARQUEE_ITEMS,
        ...$1b8e0994176c9ade$var$MARQUEE_ITEMS
    ]; // duplicate for seamless loop
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "marquee-wrap",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "marquee-track",
            children: items.map((text, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "marquee-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "marquee-text",
                            children: text
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "marquee-dot",
                            children: "\u25CF"
                        })
                    ]
                }, i))
        })
    });
}
// ─────────────────────────────────────────────────────────────────
// MOCK SCREENS
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$MockScreens() {
    const deviceType = $1b8e0994176c9ade$var$useDeviceCycle(5000);
    const mode = $1b8e0994176c9ade$var$useCurrentMode();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mock-section",
        children: $1b8e0994176c9ade$var$MOCK_ROWS.map((row, i)=>{
            const assetSrc = $1b8e0994176c9ade$var$PHONE_ASSETS[row.assetKey]?.[mode];
            const screen = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `device-frame device-frame--${deviceType}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "device-frame__notch"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "device-frame__screen",
                        children: assetSrc ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: assetSrc,
                            alt: row.screenlabel,
                            className: "device-frame__img"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "device-frame__placeholder",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: row.screenlabel
                            })
                        })
                    })
                ]
            });
            const copy = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mock-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-label",
                        children: row.label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "mock-title",
                        children: row.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mock-body",
                        children: row.body
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: "mock-bullets",
                        children: row.bullets.map((b, j)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bullet-check",
                                        children: "\u2713"
                                    }),
                                    " ",
                                    b
                                ]
                            }, j))
                    })
                ]
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `mock-row${row.flip ? ' flipped' : ''}`,
                children: row.flip ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        copy,
                        screen
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        screen,
                        copy
                    ]
                })
            }, i);
        })
    });
}
// ─────────────────────────────────────────────────────────────────
// FEATURES SECTION
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Features() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "features",
        className: "section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "section-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-label",
                        children: "What You Get"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "section-title",
                        children: [
                            "Everything your",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "golf group needs."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-desc",
                        children: "Simple scoring, every betting format, team events, and personalized recaps \u2014 from a casual foursome to a large event."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "features-grid",
                children: $1b8e0994176c9ade$var$FEATURES.map((f)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "feature-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "feature-num",
                                children: f.num
                            }),
                            f.badge ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "feature-title",
                                        children: f.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            display: 'inline-block',
                                            backgroundColor: 'rgba(22, 163, 74, 0.15)',
                                            color: '#16a34a',
                                            fontWeight: 600,
                                            fontSize: '11px',
                                            borderRadius: '6px',
                                            padding: '2px 8px'
                                        },
                                        children: f.badge
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "feature-title",
                                children: f.title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "feature-desc",
                                children: f.desc
                            })
                        ]
                    }, f.num))
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────
// RECAPS SECTION
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Recaps() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "recaps",
        className: "section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "section-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-label",
                        children: "Sample Recaps"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "section-title",
                        children: "A taste of the drama."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-desc",
                        children: "Every recap is unique \u2014 built from your actual scores, streaks, and betting outcomes."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "recap-grid",
                children: $1b8e0994176c9ade$var$RECAPS.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "recap-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "recap-style",
                                children: r.style
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "recap-quote",
                                children: r.quote
                            })
                        ]
                    }, r.style))
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────
// WATCH LIVE SECTION
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$WatchLive() {
    const screenType = $1b8e0994176c9ade$var$useScreenCycle(5000);
    const mode = $1b8e0994176c9ade$var$useCurrentMode();
    const [expandedVideo, setExpandedVideo] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "watch-live",
        className: "section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "section-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-label",
                        children: "Watch Live"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "section-title",
                        children: [
                            "Share the action",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "with everyone."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-desc",
                        children: "Public pages anyone can access \u2014 no app, no login. Put the leaderboard on the clubhouse TV or send the link to friends and family following from home."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "watch-live-rows",
                children: $1b8e0994176c9ade$var$WATCH_LIVE_ITEMS.map((item, i)=>{
                    const videoSrc = $1b8e0994176c9ade$var$VIDEO_ASSETS[item.assetKey]?.[mode];
                    const screen = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `screen-frame screen-frame--${screenType}`,
                        onClick: ()=>setExpandedVideo({
                                src: videoSrc,
                                label: item.label
                            }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "screen-frame__bezel",
                                children: [
                                    screenType === 'tv' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "screen-frame__speaker screen-frame__speaker--left",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "screen-frame__viewport",
                                        children: videoSrc ? /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                                            src: videoSrc,
                                            autoPlay: true,
                                            muted: true,
                                            loop: true,
                                            playsInline: true,
                                            className: "screen-frame__video"
                                        }, `${item.assetKey}-${mode}`) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "screen-frame__placeholder",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    item.label,
                                                    " \u2014 ",
                                                    screenType === 'tv' ? 'TV' : 'MacBook',
                                                    " view"
                                                ]
                                            })
                                        })
                                    }),
                                    screenType === 'tv' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "screen-frame__speaker screen-frame__speaker--right",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "screen-frame__play-hint"
                            }),
                            screenType === 'macbook' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "screen-frame__base"
                            })
                        ]
                    });
                    const copy = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mock-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "section-label",
                                children: item.label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mock-title",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mock-body",
                                children: item.body
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `mock-row${item.flip ? ' flipped' : ''}`,
                        children: item.flip ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                copy,
                                screen
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                screen,
                                copy
                            ]
                        })
                    }, i);
                })
            }),
            expandedVideo && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "video-modal-overlay",
                onClick: ()=>setExpandedVideo(null),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "video-modal-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "video-modal-close",
                            onClick: ()=>setExpandedVideo(null),
                            children: "\xd7"
                        }),
                        expandedVideo.src ? /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                            src: expandedVideo.src,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            playsInline: true,
                            controls: true
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "video-modal-placeholder",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    expandedVideo.label,
                                    " \u2014 video coming soon"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "video-modal-label",
                            children: expandedVideo.label
                        })
                    ]
                })
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────
// EVENTS SECTION
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Events() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "events",
        className: "section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "section-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-label",
                        children: "Team Events"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "section-title",
                        children: "Your own Ryder Cup."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-desc",
                        children: "Organize multi-round team events with 8\u2013200+ players. Draft teams, assign groups, and track points across rounds."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "events-grid",
                children: $1b8e0994176c9ade$var$EVENT_FEATURES.map((e)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "event-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: e.title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: e.desc
                            })
                        ]
                    }, e.title))
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────
// PRICING SECTION
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Pricing() {
    const [billing, setBilling] = (0, $acw62.useState)('monthly');
    const isAnnual = billing === 'annual';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "pricing",
        className: "section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "section-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-label",
                        children: "Pricing"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "section-title",
                        children: "Pick your tee box."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "section-desc",
                        children: "Start free. Upgrade when you're hooked. In-app upgrades for your own golf group."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pricing-toggle-wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "billing-toggle",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `billing-btn${billing === 'monthly' ? ' active' : ''}`,
                                onClick: ()=>setBilling('monthly'),
                                children: "Monthly"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `billing-btn${billing === 'annual' ? ' active' : ''}`,
                                onClick: ()=>setBilling('annual'),
                                children: "Annual"
                            })
                        ]
                    }),
                    isAnnual && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "annual-pill",
                        children: $1b8e0994176c9ade$var$ANNUAL.topPill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pricing-grid-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pricing-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-tier",
                                children: "Red Tees"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-price",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-amount",
                                        children: "$0"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-period",
                                        children: "forever"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-billed-note",
                                children: "\xa0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-divider"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "pricing-bullets",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " 2 recaps / month"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Roast & Sunday at the Majors styles only"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " 5 core betting games"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Unlimited rounds"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-store-note",
                                children: "Available in the Side Loop app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pricing-card highlighted",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-badge",
                                children: "Most Popular"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-tier",
                                children: "Blue Tees"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-price",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-amount",
                                        children: isAnnual ? $1b8e0994176c9ade$var$ANNUAL.blueMonthlyDisplay : '$5.99'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-period",
                                        children: "/ month"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-billed-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-billed-note",
                                        children: isAnnual ? $1b8e0994176c9ade$var$ANNUAL.blueTotalNote : '\u00a0'
                                    }),
                                    isAnnual && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-savings",
                                        children: $1b8e0994176c9ade$var$ANNUAL.blueSave
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-divider"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "pricing-bullets",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " 5 recaps / month"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " 6 recap styles"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Course search + Scorecard Scanning"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Round history"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-store-note",
                                children: "Available in the Side Loop app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pricing-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-tier",
                                children: "Championship Tees"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-price",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-amount",
                                        children: isAnnual ? $1b8e0994176c9ade$var$ANNUAL.champMonthlyDisplay : '$9.99'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-period",
                                        children: "/ month"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-billed-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-billed-note",
                                        children: isAnnual ? $1b8e0994176c9ade$var$ANNUAL.champTotalNote : '\u00a0'
                                    }),
                                    isAnnual && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-savings",
                                        children: $1b8e0994176c9ade$var$ANNUAL.champSave
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-divider"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "pricing-bullets",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " 20 recaps / month"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " All recap styles"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Multi-group Events"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Priority support"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-store-note",
                                children: "Available in the Side Loop app"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pricing-card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-tier",
                                children: "Voice Scoring"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-price",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-amount",
                                        children: isAnnual ? $1b8e0994176c9ade$var$ANNUAL.voiceMonthlyDisplay : '$4.99'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-period",
                                        children: "/ month"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-billed-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-billed-note",
                                        children: isAnnual ? $1b8e0994176c9ade$var$ANNUAL.voiceTotalNote : ' '
                                    }),
                                    isAnnual && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pricing-savings",
                                        children: $1b8e0994176c9ade$var$ANNUAL.voiceSave
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-divider"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "pricing-bullets",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Voice scoring for every hole"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Configure games and side bets hands-free"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Add spoken color commentary to your recaps"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bullet-check",
                                                children: "\u2713"
                                            }),
                                            " Works with any tier"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricing-store-note",
                                children: "Available in the Side Loop app"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "club-section",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "section-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "section-label",
                                children: "For Golf Clubs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "section-title",
                                children: "Run it for your club."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "section-desc",
                                children: "Club-managed calcuttas and leagues, purchased and run from the web."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pricing-grid-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-card coming-soon",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-badge pricing-badge--muted",
                                        children: "Coming Soon"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-tier",
                                        children: "Calcutta Management"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-price",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pricing-amount pricing-amount--placeholder",
                                            children: "\u2014"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-billed-row",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pricing-billed-note",
                                            children: "\xa0"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-divider"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "pricing-bullets",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Team auctions with live bidding"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Automatic payout calculation by finish"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Public auctioneer and leaderboard screens"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Run alongside any event format"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: $1b8e0994176c9ade$var$APP_URL,
                                        className: "pricing-cta secondary",
                                        "aria-disabled": "true",
                                        children: "Notify Me"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pricing-card coming-soon",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-badge pricing-badge--muted",
                                        children: "Coming Soon"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-tier",
                                        children: "League Management"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-price",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pricing-amount pricing-amount--placeholder",
                                            children: "\u2014"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-billed-row",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pricing-billed-note",
                                            children: "\xa0"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pricing-divider"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "pricing-bullets",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Recurring weekly or monthly schedules"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Season-long standings across rounds"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Handicap tracking and automatic flights"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bullet-check",
                                                        children: "\u2713"
                                                    }),
                                                    " Player dues and prize-pool tracking"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: $1b8e0994176c9ade$var$APP_URL,
                                        className: "pricing-cta secondary",
                                        "aria-disabled": "true",
                                        children: "Notify Me"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────
// FOOTER — Landing page (4 columns)
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$Footer() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
        className: "landing-footer",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "landing-footer-grid",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "landing-footer-col landing-footer-brand",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jCupm.default), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "landing-footer-col",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "landing-footer-heading",
                            children: "Events"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "landing-footer-links",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/dashboard.html",
                                        children: "Dashboard"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/leaderboard.html",
                                        children: "Leaderboard"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/pairings.html",
                                        children: "Pairings"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/draft.html",
                                        children: "Draft"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/admin.html",
                                        children: "Admin"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "landing-footer-col",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "landing-footer-heading",
                            children: "Calcutta"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "landing-footer-links",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/calcutta.html",
                                        children: "Calcutta Admin"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/calcutta-live.html",
                                        children: "Live View"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/calcutta-auctioneer.html",
                                        children: "Auctioneer"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/calcutta-spotter.html",
                                        children: "Spotter"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "landing-footer-col",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "landing-footer-heading",
                            children: "Platform"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "landing-footer-links",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/mysideloop.html",
                                        children: "My Side Loop"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/leagues.html",
                                        children: "Leagues"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/course.html",
                                        children: "Course Directory"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/help.html",
                                        children: "Help Center"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "landing-footer-col",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "landing-footer-heading",
                            children: "Support"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "landing-footer-links",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "mailto:support@sideloop.golf",
                                        children: "support@sideloop.golf"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/report-course.html",
                                        children: "Report course data issue"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/submit-game.html",
                                        children: "Submit a side game idea"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/privacy.html",
                                        children: "Privacy Policy"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "/terms.html",
                                        children: "Terms of Service"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// ─────────────────────────────────────────────────────────────────
// THEME TOGGLE
// ─────────────────────────────────────────────────────────────────
function $1b8e0994176c9ade$var$ThemeToggle() {
    const [theme, setTheme] = (0, $acw62.useState)('dark');
    const [open, setOpen] = (0, $acw62.useState)(false);
    const applyTheme = (0, $acw62.useCallback)((mode)=>{
        setTheme(mode);
        if (mode === 'light') document.documentElement.setAttribute('data-mode', 'light');
        else document.documentElement.removeAttribute('data-mode');
        setOpen(false);
    }, []);
    // Close panel on outside click
    const handleOutside = (0, $acw62.useCallback)((e)=>{
        if (!e.target.closest('.theme-toggle')) setOpen(false);
    }, []);
    (0, $acw62.useState)(()=>{
        document.addEventListener('click', handleOutside);
        return ()=>document.removeEventListener('click', handleOutside);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "theme-toggle",
        children: [
            open && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "theme-panel",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "theme-panel-label",
                        children: "Appearance"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "theme-buttons",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `theme-btn${theme === 'dark' ? ' active' : ''}`,
                                onClick: ()=>applyTheme('dark'),
                                children: "\uD83C\uDF19 Dark"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `theme-btn${theme === 'light' ? ' active' : ''}`,
                                onClick: ()=>applyTheme('light'),
                                children: "\u2600\uFE0F Light"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "theme-note",
                        children: "Switches all text, backgrounds, borders, and colors."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "theme-fab",
                onClick: ()=>setOpen((o)=>!o),
                children: theme === 'dark' ? "\uD83C\uDF19" : "\u2600\uFE0F"
            })
        ]
    });
}
function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "grain-overlay"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg-gradient"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Nav, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Hero, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Marquee, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$MockScreens, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$WatchLive, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Features, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Events, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Recaps, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Pricing, {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$Footer, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1b8e0994176c9ade$var$ThemeToggle, {})
        ]
    });
}



var $9HyzH = parcelRequire("9HyzH");
(0, $9HyzH.initStickyFooter)({
    isLanding: true
});
(0, $aRPiL.createRoot)(document.getElementById('root')).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=repo.847c5521.js.map
